import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-desktop-app',
  templateUrl: './desktop-app.component.html',
  styleUrls: ['./desktop-app.component.scss']
})
export class DesktopAppComponent implements OnInit, OnChanges {
  isLinux = false;
  isWindows = false;
  isMac = false;
  downloadPath: string;
  @Input() download;
  @Output() downloadingPath = new EventEmitter<string>();
  constructor(
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    private toastr: ToastrService,
  ) { 
        // Configure the layout
        this._fuseConfigService.config = {
          layout: {
            navbar: {
              hidden: true
            },
            toolbar: {
              hidden: true
            },
            footer: {
              hidden: true
            },
            sidepanel: {
              hidden: true
            }
          }
        };
  }

  ngOnInit() {
    let os = navigator.appVersion;
    if (os.indexOf('Linux') != -1) {
      this.isLinux = true;
      this.downloadPath = '../../../../assets/desktopApp/linux/openworx.AppImage';
      this.downloadingPath.emit(this.downloadPath);
    }
    else if (os.indexOf('Windows') != -1) {
      this.isWindows = true;
      this.downloadPath = '../../../../assets/desktopApp/windows/openworx.exe';
      this.downloadingPath.emit(this.downloadPath);
    }
    else if (os.indexOf('Macintosh') != -1) {
      this.isMac = true;
      this.downloadPath = '../../../../assets/desktopApp/mac/openworx.pkg'; 
      this.downloadingPath.emit(this.downloadPath);
    }
  }

  ngOnChanges(): void {
    if (this.download){
      // this.downloadFile(this.downloadPath);
      this.router.navigate(['/login']);
      this.toastr.info('Login To The Desktop App At First.');
      this.toastr.success('Desktop Application Downloaded Successfully');
    }
  }

  downloadFile(data): void {
    const url = data;
    const e = document.createElement('a');
    e.href = url;
    e.download = url;
    document.body.appendChild(e);
    e.click();
    document.body.removeChild(e);
    this.toastr.success('Desktop Application Downloaded Successfully');
 }

}
